import React from "react";
import "./preloader.css";

const Preloader = ({ onEnter }) => {
return (
<div className="preloader">
<div className="loader-circle"></div>
<h2>Umm Kulthum</h2>
<button className="enter-btn" onClick={onEnter}>
Enter Experience
</button>
</div>

);
};

export default Preloader;